<template>
  <div class="position-relative">
    <div :class="[Shippingloading ? 'loading' : '']">
      <div class="border-top border-bottom">
        <div class="btn-group flex-wrap w-100 pt-3 px-3 bg-light">
          <!-- Download -->
          <div>
            <button
              class="btn btn-primary mr-3"
              @click="exportReportShippingChargeBilling"
            >
              <i class="fa-solid fa-file-arrow-down mr-1" /> {{ $t("Download") }}
            </button>
          </div>

          <!-- search -->
          <div class="toobar-search mr-2">
            <div class="input-group bg-white">
              <input 
                type="text" 
                @keydown.enter.prevent="search()" 
                v-model="paramsQuery.search" 
                name="search"
                :placeholder="$t('Search by order no., receiver, tracking no...')" 
                style="min-width: 225px"
                class="border-right-0 form-control pl-2 px-0" 
              >
              <span class="input-group-append">
                <button 
                  class="btn btn-outline-normal border-left-0 btn-search" 
                  type="button"
                  @click="search"
                >
                  <i class="far fa-search" />
                </button>
              </span>
            </div>
          </div>

          <!-- datepicker and more filter -->
          <div class="form-group align-items-center d-flex mr-3 md-block">
            <div class="input-group w-auto">
              <span class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fas fa-calendar-alt" />
                </span>
              </span>
              <input 
                type="text" 
                class="form-control"
                v-model="startDate"
                disabled
              >
              <button
                @click="openFilter"
                type="button"
                class="btn btn-outline-normal rounded-left-0 d-flex"
                data-toggle="modal"
                data-target="#filter"
              >
                <i class="fas fa-sliders-v mr-2 mt-1" />
                {{ $t("More Filters") }}
                <span
                  v-if="countFilter > 0"
                  class="badge badge-secondary ml-2"
                >{{ countFilter }}</span>
              </button>
            </div>
          </div>

          <!-- perpage -->
          <div class="dataTables_length ml-auto mb-0">
            <PerPage @per-page="setPerPage" />
          </div>
        </div>
      </div>
      <div 
        :class="['table-responsive mt-0 data-nowrap table-hover table-order']" 
        id="table-order"
      >
        <div class="vuetable-wrapper datatable-scroll">
          <vuetable 
            ref="vuetable" 
            :no-data-template="$t('No Data Available')"
            :fields="table.fields" 
            data-path="data" 
            pagination-path="" 
            :api-mode="false"
            :data-manager="dataManager" 
            @vuetable:loaded="vuetableLoaded" 
            @vuetable:loading="vuetableLoading"
            @vuetable:initialized="onInitialized"
            @vuetable:pagination-data="onPaginationData" 
          >
            <template 
              slot="carrier" 
              slot-scope="props"
            >
              <img 
                v-if="!props.rowData.carrier_channel_logo" 
                class="rounded pointer" 
                width="25" 
                height="25" 
                :src="$storeIndex.getImageGobalAssets('')" 
                alt=""
              >
              <img 
                v-else 
                :src="props.rowData.carrier_channel_logo" 
                width="20" 
                height="20"
              >
            </template>
            <template 
              slot="refund_charge" 
              slot-scope="props"
            >
              <div 
                class="text-grey-800" 
                v-if="((parseFloat(props.rowData.actual_price) + parseFloat(props.rowData.actual_cod_fee) + parseFloat(props.rowData.actual_remote_price) + parseFloat(props.rowData.actual_tourism_price) + parseFloat(props.rowData.actual_on_holiday_price) + parseFloat(props.rowData.actual_warranty_price) + parseFloat(props.rowData.actual_return_price))) == 0 && (parseFloat(props.rowData.estimate_price) + parseFloat(props.rowData.estimate_cod_fee) + parseFloat(props.rowData.estimate_remote_price) + parseFloat(props.rowData.estimate_tourism_price) + parseFloat(props.rowData.estimate_on_holiday_price) + parseFloat(props.rowData.estimate_warranty_price) + parseFloat(props.rowData.estimate_island_price)) >= 0"
              >
                0.00
              </div>
              <div 
                class="text-grey-800" 
                v-else-if="(
                  (parseFloat(props.rowData.estimate_price) + parseFloat(props.rowData.estimate_cod_fee) + parseFloat(props.rowData.estimate_remote_price) + parseFloat(props.rowData.estimate_tourism_price) + parseFloat(props.rowData.estimate_on_holiday_price) + parseFloat(props.rowData.estimate_warranty_price) + parseFloat(props.rowData.estimate_island_price))
                  ==
                  (parseFloat(props.rowData.actual_price) + parseFloat(props.rowData.actual_cod_fee) + parseFloat(props.rowData.actual_remote_price) + parseFloat(props.rowData.actual_tourism_price) + parseFloat(props.rowData.actual_on_holiday_price) + parseFloat(props.rowData.actual_warranty_price) + parseFloat(props.rowData.actual_return_price)))"
              >
                0.00
              </div>
              <div 
                class="text-danger-400" 
                v-else-if="(
                  (parseFloat(props.rowData.estimate_price) + parseFloat(props.rowData.estimate_cod_fee) + parseFloat(props.rowData.estimate_remote_price) + parseFloat(props.rowData.estimate_tourism_price) + parseFloat(props.rowData.estimate_on_holiday_price) + parseFloat(props.rowData.estimate_warranty_price) + parseFloat(props.rowData.estimate_island_price))
                  -
                  (parseFloat(props.rowData.actual_price) + parseFloat(props.rowData.actual_cod_fee) + parseFloat(props.rowData.actual_remote_price) + parseFloat(props.rowData.actual_tourism_price) + parseFloat(props.rowData.actual_on_holiday_price) + parseFloat(props.rowData.actual_warranty_price) + parseFloat(props.rowData.actual_return_price))) 
                  < 0"
              >
                {{ formatRefundAndCharge((parseFloat(props.rowData.estimate_price) + parseFloat(props.rowData.estimate_cod_fee) + parseFloat(props.rowData.estimate_remote_price) + parseFloat(props.rowData.estimate_tourism_price) + parseFloat(props.rowData.estimate_on_holiday_price) + parseFloat(props.rowData.estimate_warranty_price) + parseFloat(props.rowData.estimate_island_price)) - (parseFloat(props.rowData.actual_price) + parseFloat(props.rowData.actual_cod_fee) + parseFloat(props.rowData.actual_remote_price) + parseFloat(props.rowData.actual_tourism_price) + parseFloat(props.rowData.actual_on_holiday_price) + parseFloat(props.rowData.actual_warranty_price) + parseFloat(props.rowData.actual_return_price))) }}
              </div>
              <div
                
                class="text-success-400" 
                v-else-if="(
                  (parseFloat(props.rowData.estimate_price) + parseFloat(props.rowData.estimate_cod_fee) + parseFloat(props.rowData.estimate_remote_price) + parseFloat(props.rowData.estimate_tourism_price) + parseFloat(props.rowData.estimate_on_holiday_price) + parseFloat(props.rowData.estimate_warranty_price) + parseFloat(props.rowData.estimate_island_price))
                  -
                  (parseFloat(props.rowData.actual_price) + parseFloat(props.rowData.actual_cod_fee) + parseFloat(props.rowData.actual_remote_price) + parseFloat(props.rowData.actual_tourism_price) + parseFloat(props.rowData.actual_on_holiday_price) + parseFloat(props.rowData.actual_warranty_price) + parseFloat(props.rowData.actual_return_price))) 
                  > 0"
              >
                {{ formatRefundAndCharge((parseFloat(props.rowData.estimate_price) + parseFloat(props.rowData.estimate_cod_fee) + parseFloat(props.rowData.estimate_remote_price) + parseFloat(props.rowData.estimate_tourism_price) + parseFloat(props.rowData.estimate_on_holiday_price) + parseFloat(props.rowData.estimate_warranty_price) + parseFloat(props.rowData.estimate_island_price)) - (parseFloat(props.rowData.actual_price) + parseFloat(props.rowData.actual_cod_fee) + parseFloat(props.rowData.actual_remote_price) + parseFloat(props.rowData.actual_tourism_price) + parseFloat(props.rowData.actual_on_holiday_price) + parseFloat(props.rowData.actual_warranty_price) + parseFloat(props.rowData.actual_return_price))) }}
              </div>
            </template>
            <template 
              slot="order_number" 
              slot-scope="props"
            >
              <a 
                class="text-primary" 
                :href="'/app/orders/'+props.rowData.sales_order_id" 
                target="_blank"
              >
                <span
                  v-if="$storeIndex.notRunningNo(props.rowData)"
                  v-tooltip:top="$t('Order created successfully, you can proceed to the next step.')"
                  :data-original-title="$t('Order created successfully, you can proceed to the next step.')"
                >
                  <i
                    class="icon-spinner2 spinner" 
                  />
                  OD**********
                </span>
                <span 
                  v-else
                  class="order-number"
                >
                  {{ props.rowData.order_number }}
                </span>
              </a>
            </template>
            <template slot="tableFooter">
              <tr style="background:#FAFAFA">
                <th
                  v-for="(field, indexField) in dataFooterFields"
                  :class="field.dataClass"
                  :key="indexField + '_' + field.visible"
                >
                  <template v-if="field.name == 'carrier'">
                    {{ $t('Total') }}
                  </template>
                  <template v-if="field.name == 'estimate_weight'">
                    {{ totalEstimateWeight | formatNumberWeight }}
                  </template>
                  <template v-if="field.name == 'estimate_price'">
                    {{ totalEstimatePrice | formatNumber }}
                  </template>
                  <template v-if="field.name == 'actual_price'">
                    {{ totalActualPrice | formatNumber }}
                  </template>
                  <template v-if="field.name == 'estimate_cod_amount'">
                    {{ totalEstimateCodAmount | formatNumber }}
                  </template>
                  <template v-if="field.name == 'estimate_cod_fee'">
                    {{ totalEstimateCodFee | formatNumber }}
                  </template>
                  <template v-if="field.name == 'estimate_remote_price'">
                    {{ totalRemoteAreaPrice | formatNumber }}
                  </template>
                  <template v-if="field.id == 'estimate_tourism_price'">
                    {{ totalTourismPrice | formatNumber }}
                  </template>
                  <template v-if="field.id == 'estimate_total_price'">
                    {{ totalEstimateTotalPrice | formatNumber }}
                  </template>
                  <template v-if="field.name == 'actual_weight'">
                    {{ totalActualWeight | formatNumberWeight }}
                  </template>
                  <template v-if="field.name == 'actual_return_price'">
                    {{ totalActualReturnPrice | formatNumber }}
                  </template>
                  <template v-if="field.id == 'actual_total_price'">
                    {{ totalActualTotalPrice | formatNumber }}
                  </template>
                  <template v-if="field.name == 'refund_charge'">
                    {{ totalRefundCharge | formatNumber }}
                  </template>
                </th>
              </tr>
            </template>
          </vuetable>
        </div>
      </div>
      <div class="datatable-footer pl-3 pr-3">
        <vuetable-pagination-info 
          class="dataTables_info" 
          ref="paginationInfo"
          :no-data-template="$t('No relevant data')"
          :info-template="$t('Displaying {from} to {to} of {total} items')"
        />
        <div class="dataTables_paginate paging_simple_numbers mb-0">
          <vuetable-pagination 
            ref="pagination" 
            pagination-path="pagination"
            @vuetable-pagination:change-page="onChangePage"
          />
        </div>
      </div>
    </div>

    <ShippingExpensesDetailTableFiltersMore
      v-if="isFilter"
      :shipment-status="shipmentStatus"
      :shipping-method="shippingMethod"
    />
  </div>
</template>

<script>
  import numeral from 'numeral'
  import Api from "@/services/endpoint/tenant.service";
  import PerPage from "../PerPage.vue";
  import Vuetable from "vuetable-2";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo";
  import ShippingExpensesDetail from "../assets/js/ShippingExpensesDetail_fields.js";
  import ShippingExpensesDetailTableFiltersMore from "./ShippingExpensesDetailTableFiltersMore";
  import { convertTimezone } from "@/common/tenancy/convertTimezone";
  import eventBus from '@/plugins/eventBus';
  import moment from "moment";
  import Cookies from "js-cookie";

  export default {
    name: "ShippingExpenseDetailTable",
    components: {
      PerPage,
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
      ShippingExpensesDetailTableFiltersMore
    },
    data: function () {
      return {
        Shippingloading: false,
        vuetableFields: false,
        startDate: null,
        paramsQuery: {
          limit: 10,
          page: 1,
          sort: 'topack_date|asc',
          search: ''
        },
        countFilter: 0,
        isFilter: false,
        table: {
          fields: ShippingExpensesDetail,
        },
        shipmentStatus: [],
        shippingMethod: [],
        dataVueTable: {},
        dataTable: [],
        dataFooterFields: [],
      }
    },
    async created() {
      this.startDate = this.$route.query.topack_date
      this.paramsQuery.start = convertTimezone.localToUtc(`${this.$route.query.topack_date}`)
      this.paramsQuery.end = `${this.$route.query.topack_date} 16:59:59`
      if (this.$route.query.shipment_status) {
        this.paramsQuery.shipment_status = this.$route.query.shipment_status
      }
      if (this.$route.query.shipping_method_ids) {
        this.paramsQuery.shipping_method_ids = typeof this.$route.query.shipping_method_ids == 'string' ? [this.$route.query.shipping_method_ids] : this.$route.query.shipping_method_ids
      }
      // open eventBus for websocket
      eventBus.on('updateOrderNumber', payload => {
        const orders = payload.reduce((param, res) => ({...param, [res.id]: res }), {})
        let updated = 0
        let dataTable = this.dataVueTable
        dataTable.data = dataTable.data.map((res) => {
          if (orders.hasOwnProperty(res.sales_order_id)) {
            const order = orders[res.sales_order_id]
            res.running_no = order.running_no
            res.internal_number = order.order_number
            res.order_number = order.order_number
            updated++
          }
          return res
        })
        this.$nextTick(() => {
          if (updated) {
            this.setVueTableData(dataTable)
          }
          eventBus.off('updateOrderNumber', payload)
        })
      })
    },
    computed: {
      footerTableFields() {
        if(this.vuetableFields !== false) {
          return this.$refs.vuetable.tableFields;
        }else {
          return [];
        }
      },
      totalEstimateWeight() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((item) => { return parseFloat(item.estimate_weight) });
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        }
      },
      totalEstimatePrice() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((item) => { return parseFloat(item.estimate_price) });
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        }
      },
      totalActualPrice() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((item) => { return parseFloat(item.actual_price) });
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        }
      },
      totalEstimateCodAmount() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((item) => { return parseFloat(item.estimate_cod_amount) });
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        }
      },
      totalEstimateCodFee() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((item) => { return parseFloat(item.estimate_cod_fee) });
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        }
      },
      totalRemoteAreaPrice() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((item) => { return parseFloat(item.estimate_remote_price) });
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        }
      },
      totalTourismPrice() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((item) => { return item.actual_tourism_price > 0 ? parseFloat(item.actual_tourism_price) : (parseFloat(item.estimate_island_price) + parseFloat(item.estimate_tourism_price)) });
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        }
      },
      totalEstimateTotalPrice() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((data) => { return parseFloat(data.estimate_price) + parseFloat(data.estimate_cod_fee) + parseFloat(data.estimate_remote_price) + parseFloat(data.estimate_tourism_price) + parseFloat(data.estimate_on_holiday_price) + parseFloat(data.estimate_warranty_price) + parseFloat(data.estimate_island_price)});
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        } 
      },
      totalActualWeight() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((item) => { return parseFloat(item.actual_weight) });
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        } 
      },
      totalActualReturnPrice() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((item) => { return parseFloat(item.actual_return_price) });
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        } 
      },
      totalActualTotalPrice() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalCount = dataTable.map((data) => { return parseFloat(data.actual_price) + parseFloat(data.actual_cod_fee) + parseFloat(data.actual_remote_price) + parseFloat(data.actual_tourism_price) + parseFloat(data.actual_on_holiday_price) + parseFloat(data.actual_warranty_price) + parseFloat(data.actual_return_price) });
          return totalCount.reduce((total, item) => total + item);
        }else {
          return 0
        } 
      },
      totalRefundCharge() {
        let dataTable = this.dataTable.data;
        if (dataTable && dataTable.length > 0) {
          let totalEstimateTotalPrice = dataTable.map(function (data) {
            let totalActualTotalPrice = (parseFloat(data.actual_price) + parseFloat(data.actual_cod_fee) + parseFloat(data.actual_remote_price) + parseFloat(data.actual_tourism_price) + parseFloat(data.actual_on_holiday_price) + parseFloat(data.actual_warranty_price) + parseFloat(data.actual_return_price))
            if (totalActualTotalPrice === 0) {
              return 0;
            }
            return (parseFloat(data.estimate_price) + parseFloat(data.estimate_cod_fee) + parseFloat(data.estimate_remote_price) + parseFloat(data.estimate_tourism_price) + parseFloat(data.estimate_on_holiday_price) + parseFloat(data.estimate_warranty_price) + parseFloat(data.estimate_island_price));
          })
          let totalActualTotalPrice = dataTable.map((data) => { return parseFloat(data.actual_price) + parseFloat(data.actual_cod_fee) + parseFloat(data.actual_remote_price) + parseFloat(data.actual_tourism_price) + parseFloat(data.actual_on_holiday_price) + parseFloat(data.actual_warranty_price) + parseFloat(data.actual_return_price) });
          totalEstimateTotalPrice = totalEstimateTotalPrice.reduce((total, item) => total + item);
          totalActualTotalPrice = totalActualTotalPrice.reduce((total, item) => total + item);
          return totalActualTotalPrice - totalEstimateTotalPrice;
        }else {
          return 0
        } 
      }
    },
    methods: {
      setVueTableData(data) {
        this.dataVueTable = data
        this.$refs.vuetable.setData(data)
      },
      formatRefundAndCharge(data) {
        if(data < 0){
          return "-"+numeral(data).format("0,0.00").replace("-","");
        }else{
          return "+"+numeral(data).format("0,0.00");
        }
      },
      openFilter() {
        this.isFilter = false;
        this.$nextTick(() => {
          this.isFilter = true;
        });
      },
      onInitialized(fields) {
        this.vuetableFields = fields.filter((field) => field.togglable);
      },
      templateCustom(e) {
        let option = "";
        if(e.id == 0 && e.name == 'Carrier'){
          option = "<div class='list-item d-flex'><div class='item-content'><div class='item-name'>" + this.$t(e.name) + "</div></div></div>";
        }else
        if (e.text == "Searching…") {
          option = this.$t("Searching...");
        } else {
          let image = '';
          if(e.integration.integration_type_id){
            image = '<img class="rounded mr-2" src="'+ e.integration.integration_type.logo +'" width="20">';
          }else{
            image = '<img class="rounded mr-2" src="'+ this.$storeIndex.getImageSrc('carrier/' + e.integration.integration_type_id) +'" width="20">';
          }
          option = "<div class='list-item d-flex'><div class='item-image'>"+image+"</div><div class='item-content'><div class='item-name'>" + this.$t(e.integration.name) + "</div></div></div>";
        }
        return option;
      },
      templateCustomSelect(e) {
        let image = '';
        var name = e.name;
        if (this.$storeIndex.isset(() => e.integration.name)) {
          name = e.integration.name;
        }
        if(e.id == 0 && e.name == 'Carrier' || e.id == ''){
          var html = "<div class='list-item d-flex'><div class='item-content'><div class='item-name'>" + this.$t(e.name) + "</div></div></div>";
        }else
        if(e.id){
          if(e.integration.integration_type_id){
            image = '<img class="rounded mr-2" src="'+ e.integration.integration_type.logo +'" width="20">';
          }else{
            image = '<img class="rounded mr-2" src="'+ this.$storeIndex.getImageSrc('carrier/' + e.integration.integration_type_id) +'" width="20">';
          }
          var html = "<div class='list-item d-flex'><div class='item-image'>"+image+"</div><div class='item-content'><div class='item-name'>" + this.$t(name) + "</div></div></div>";
        }
        return html;
      },
      dataManager(sortOrder, pagination) {
        if (sortOrder.length > 0) {
          this.paramsQuery.sort = sortOrder.map((item) => `${item.sortField}|${item.direction}`).join(',')
        }
        this.setParams();
      },
      onPaginationData(tablePagination) {
        this.$refs.paginationInfo.setPaginationData(tablePagination);
        this.$refs.pagination.setPaginationData(tablePagination);
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      },
      search() {
        this.setParams();
      },
      setPerPage(perPage) {
        this.paramsQuery.page = 1;
        this.$refs.vuetable.currentPage = 1;
        this.paramsQuery.limit = perPage;
        this.setParams();
      },
      vuetableLoaded() {
        // this.onload = false;
      },
      vuetableLoading() {},
      async setParams() {
        try {
          this.Shippingloading = true;
          this.paramsQuery.page = this.$refs.vuetable.currentPage;
          let queryString = "";
          if (this.paramsQuery) {
            queryString += "?" + $.param(this.paramsQuery);
          }

          let result = await Api.ReportV2.getShippingChargeBillingDetail(queryString)
          this.dataTable = result.data;
          let data = this.$storeIndex.mutations.vueTableFormatJson(result);

          if (this.shipmentStatus.length == 0 && this.shippingMethod.length == 0) {
            this.shipmentStatus = data.filter.shipment_status;
            this.shippingMethod = data.filter.shipping_method;
          }
          this.setVueTableData(data)
          this.Shippingloading = false;
          this.$parent.hasPermission = false;
          this.$parent.onload = false;
        } catch (error) {
          this.Shippingloading = false;
          if (error.response.status == 403) {
            this.$parent.hasPermission = true;
            this.$parent.onload = false;
          } else {
            this.$router.push({ name: "t.a.home" });
          }
        }
      },
      async exportReportShippingChargeBilling() {
        let postHasPermission = await Api.Permission.postHasPermission('report_shipping_charge_download');
        if (postHasPermission.data.status) {
          let queryStringClone = JSON.parse(JSON.stringify(this.paramsQuery))
          delete queryStringClone.page
          delete queryStringClone.limit
          queryStringClone.file_name = (`Export Shipping Charger Billing Report ${moment().format('YYYY-MM-DD HH:mm:ss')}`).replaceAll(' ', '_')
          queryStringClone.offset = 0;
          let queryString = "";
          if (queryStringClone) {
            queryString += "?" + $.param(queryStringClone);
          }
          this.$store.dispatch("reports/isProgressReportShippingChargeBilling", true);
          this.$store.dispatch("reports/queryStringReportShippingChargeBilling", {
            action: 'ADD',
            payload: queryString
          });
        } else {
          let self = this;
          this.$swal({
            imageUrl: require('@/assets/images/activities/icon-access-denied.png'),
            title: self.$t('Access Denied')+' !',
            html: self.$t('You do not have permission to access this page.')+'<br/>'+self.$t('If you feel this is a mistake, contact your admin.'),
            confirmButtonText: '<i class="fa-solid fa-thumbs-up mr-1"></i>' + self.$t('OK'),
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            focusConfirm: false
          });
        }
      }
    },
    async mounted() {
      this.onload = true;
    },
    watch:{
      footerTableFields: {
        handler: function (nval, oval) {
          let newFooterTableArray = [];
          nval.forEach(element => {
            if (element.visible === true) {
              newFooterTableArray.push(element)
            }
          });
          this.$nextTick(() => {
            this.dataFooterFields = newFooterTableArray;
          });
        },
        deep: true
      },
    },
    filters: {
      formatNumber: function (value) {
        return numeral(value).format("0,0.00");
      },
      formatNumberWeight: function (value){
        return numeral(value).format("0,0.00")+' g';
      },
    },
  };

</script>
<style>
.bg-return {
  background-color: #673ab7;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/ShippingExpensesDetailTable.vue